import { useState, useEffect } from 'react';
import { api, endpoints } from '../config/api';
import { useAuth } from '../context/AuthContext';
import DataTable from '../components/DataTable';
import Modal from '../components/Modal';

function StationsPage() {
  const { token } = useAuth();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ nombre: '', orden: 1, problema: '', videoUrl: '', descripcion: '', headerText: '' });

  const load = () => api.get(endpoints.stations(), token).then(setData).catch(console.error).finally(() => setLoading(false));
  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      if (editing) await api.put(endpoints.station(editing.id), form, token);
      else await api.post(endpoints.stations(), form, token);
      setModalOpen(false);
      setEditing(null);
      setForm({ nombre: '', orden: 1, problema: '', videoUrl: '', descripcion: '', headerText: '' });
      load();
    } catch (err) {
      alert(err?.message || 'Error');
    }
  };

  const handleDelete = async (row) => {
    if (!window.confirm('¿Eliminar estación?')) return;
    try {
      await api.delete(endpoints.station(row.id), token);
      load();
    } catch (err) {
      alert(err?.message || 'Error');
    }
  };

  const columns = [
    { key: 'id', label: 'ID' },
    { key: 'nombre', label: 'Nombre' },
    { key: 'orden', label: 'Orden' },
    { key: 'headerText', label: 'Header' },
  ];

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Estaciones</h1>
        <button onClick={() => { setEditing(null); setForm({ nombre: '', orden: 1, problema: '', videoUrl: '', descripcion: '', headerText: '' }); setModalOpen(true); }} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">Nueva estación</button>
      </div>
      {loading ? <p>Cargando...</p> : <DataTable columns={columns} data={data} onEdit={(r) => { setEditing(r); setForm(r); setModalOpen(true); }} onDelete={handleDelete} />}
      <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)} title={editing ? 'Editar estación' : 'Nueva estación'}>
        <form onSubmit={handleSave} className="space-y-4">
          <div><label className="block text-sm font-medium mb-1">Nombre</label><input value={form.nombre} onChange={(e) => setForm((f) => ({ ...f, nombre: e.target.value }))} className="w-full px-3 py-2 border rounded" required /></div>
          <div><label className="block text-sm font-medium mb-1">Orden</label><input type="number" value={form.orden} onChange={(e) => setForm((f) => ({ ...f, orden: +e.target.value }))} className="w-full px-3 py-2 border rounded" /></div>
          <div><label className="block text-sm font-medium mb-1">Header Text</label><input value={form.headerText} onChange={(e) => setForm((f) => ({ ...f, headerText: e.target.value }))} className="w-full px-3 py-2 border rounded" /></div>
          <div><label className="block text-sm font-medium mb-1">Video URL</label><input value={form.videoUrl} onChange={(e) => setForm((f) => ({ ...f, videoUrl: e.target.value }))} className="w-full px-3 py-2 border rounded" /></div>
          <div><label className="block text-sm font-medium mb-1">Descripción</label><textarea value={form.descripcion} onChange={(e) => setForm((f) => ({ ...f, descripcion: e.target.value }))} className="w-full px-3 py-2 border rounded" rows={3} /></div>
          <div className="flex gap-2 justify-end">
            <button type="button" onClick={() => setModalOpen(false)} className="px-4 py-2 border rounded">Cancelar</button>
            <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">Guardar</button>
          </div>
        </form>
      </Modal>
    </div>
  );
}

export default StationsPage;
